<div class="flex w-full items-center gap-2">
    <input
        #fileInput
        [id]="inputId"
        type="file"
        class="hidden"
        [accept]="acceptedMimes"
        (change)="onFileChange($event)"
    />

    <label class="mb-0 block w-full cursor-pointer" [for]="inputId">
        <div class="w-full">
            <input
                class="w-full cursor-pointer pe-10 disabled:!bg-white"
                [value]="value?.name || (placeholderKey | translate)"
                readonly
                [disabled]="shouldDisableInput"
                type="text"
                (click)="triggerInput(fileInput)"
            />
        </div>
    </label>

    @if (!hasValue) {
        <button
            type="button"
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-400 transition-all hover:border-primary-400 hover:bg-primary-50 hover:text-slate-700"
            [appTooltip]="attachTooltipKey | translate"
            (click)="triggerInput(fileInput)"
        >
            @if (!isUploading) {
                <i class="fa-light fa-paperclip"></i>
            }
            @if (isUploading) {
                <app-loading-ring></app-loading-ring>
            }
        </button>
    }
    @if (hasValue && canRemove) {
        <button
            type="button"
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-400 transition-all hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600"
            [appTooltip]="removeTooltipKey | translate"
            (click)="onRemove()"
        >
            <i class="fa-light fa-times"></i>
        </button>
    }
</div>
